// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_shipping_tracking_body = /** @type {(inputs: {}) => string} */ () => {
	return `Once your order is shipped, you will receive a tracking number via email. You can track your parcel directly through the ACS Courier website.`
};

const el_shipping_tracking_body = /** @type {(inputs: {}) => string} */ () => {
	return `Μόλις αποσταλεί η παραγγελία σας, θα λάβετε αριθμό παρακολούθησης μέσω email. Μπορείτε να παρακολουθείτε το δέμα σας απευθείας μέσω της ιστοσελίδας της ACS Courier.`
};

const ru_shipping_tracking_body = /** @type {(inputs: {}) => string} */ () => {
	return `После отправки заказа вы получите номер для отслеживания по электронной почте. Вы сможете отследить посылку на сайте ACS Courier.`
};

const he_shipping_tracking_body = /** @type {(inputs: {}) => string} */ () => {
	return `לאחר שליחת ההזמנה, תקבלו מספר מעקב באימייל. ניתן לעקוב אחר החבילה ישירות באתר ACS Courier.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const shipping_tracking_body = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.shipping_tracking_body(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("shipping_tracking_body", locale)
	if (locale === "en") return en_shipping_tracking_body(inputs)
	if (locale === "el") return el_shipping_tracking_body(inputs)
	if (locale === "ru") return ru_shipping_tracking_body(inputs)
	if (locale === "he") return he_shipping_tracking_body(inputs)
	return "shipping_tracking_body"
};